import axios from "axios";

export async function routePricingAction(payload) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  //   const response = await axios.post(
  //     `${BASE_URL}/affiliates/trk/routePrice`,
  //     payload.body
  //   );

  console.log(payload, "payload body route pricing");

  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/affiliates/trk/routePrice`,
    payload.body
  );
  return response;
}

export async function routePricingHRAction(payload) {
  console.log(payload, "payload body route pricing hourly");

  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/affiliates/trk/routePriceHourly`,
    payload.body
  );
  return response;
}
